
const initialState = {
	offers: [],
}

// REDUCERS
export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case 'loadOffers@offers': {
			return {
				...state,
				offers: action.data
			}
		}

		default: return state
	}
}
